import { pathOr } from 'ramda';

export const parseCcnOfferResponse = (data) => {
  const base = 'getSimulationCompanyCcnOffer_simulation_company';
  return {
    ccnId: pathOr(false, [base, 'ccnId'], data),
    ccnRef: pathOr(false, [base, 'ccnRef'], data),
    ccnName: pathOr('', [base, 'ccnName'], data),
    ccnOffer: pathOr(false, [base, 'ccnOffer'], data),
    offerCodes: pathOr([], [base, 'offerCodes'], data),
    redirection: pathOr(false, [base, 'redirection'], data),
    oldCcnId: pathOr(null, [base, 'oldCcnId'], data),
    oldCcnName: pathOr(null, [base, 'oldCcnName'], data),
    comment: pathOr(null, [base, 'comment'], data),
    offerCode: pathOr(null, [base, 'offerCode'], data)
  };
};
